export default __webpack_public_path__ + "static/media/b3.3e81ec07.png";